import React, { useState, useEffect } from "react";
import { IconButton, TextField, Box, Typography } from "@mui/material";
import { ArrowDropUp, ArrowDropDown } from "@mui/icons-material";

export default function Tracker() {
  const [x, setX] = useState(
    parseInt(localStorage.getItem("tracker_x"), 10) || 0
  );
  const [y, setY] = useState(
    parseInt(localStorage.getItem("tracker_y"), 10) || 10
  );
  const [label, setLabel] = useState(
    localStorage.getItem("tracker_label") || "circles"
  );

  useEffect(() => {
    localStorage.setItem("tracker_x", x);
    localStorage.setItem("tracker_y", y);
    localStorage.setItem("tracker_label", label);
  }, [x, y, label]);

  useEffect(() => {
    if (x > y) {
      setX(y);
    }
  }, [x, y]);

  const handleCircleClick = (index) => {
    if (index === x - 1) {
      setX(x - 1);
    } else if (index === x && x < y) {
      setX(x + 1);
    }
  };

  return (
    <Box
      sx={{
        color: "white",
        backgroundColor: "black",
        minHeight: "100vh",
        padding: 2,
        display: "flex",
        flexDirection: "column",
        alignItems: "center", // This centers the content horizontally
      }}
    >
      <Typography
        variant="h3"
        component="h1"
        sx={{
          fontSize: { xs: "3rem", sm: "3.5rem", md: "4rem" },
          display: "flex",
          alignItems: "center",
          fontWeight: "bold",
        }}
      >
        <TextField
          type="text"
          value={x}
          onChange={(e) => {
            const newValue = parseInt(e.target.value, 10);
            setX(
              isNaN(newValue) || newValue > y ? y : Math.min(9999, newValue)
            );
          }}
          InputProps={{
            inputProps: {
              min: 1,
              max: 9999,
              pattern: "\\d*",
            },
          }}
          variant="outlined"
          sx={{
            width: `${String(x).length + 2}ch`,
            marginX: "20px",
            input: {
              color: "white",
              textAlign: "right",
              fontSize: { xs: "3rem", sm: "3.5rem", md: "4rem" },
              padding: "0",
            },
          }}
        />
        /
        <TextField
          type="text"
          value={y}
          onChange={(e) => {
            const newValue = parseInt(e.target.value, 10);
            setY(
              isNaN(newValue) || newValue < 1 ? 1 : Math.min(9999, newValue)
            );
          }}
          InputProps={{
            inputProps: {
              min: 1,
              max: 9999,
              pattern: "\\d*",
            },
          }}
          variant="outlined"
          sx={{
            width: `${String(y).length + 2}ch`,
            marginX: "20px",
            input: {
              color: "white",
              textAlign: "left",
              fontSize: { xs: "3rem", sm: "3.5rem", md: "4rem" },
              padding: "0",
            },
          }}
        />
      </Typography>
      <TextField
        type="text"
        value={label}
        onChange={(e) => setLabel(e.target.value)}
        variant="outlined"
        multiline
        maxRows={8}
        inputProps={{
          spellcheck: "false",
          style: {
            textAlign: "center",
            wordWrap: "break-word",
            lineHeight: "1",
          },
        }}
        sx={{
          fontSize: { xs: "3rem", sm: "3.5rem", md: "4rem" },
          width: "80vw",
          marginBottom: 2,
          "& .MuiInputBase-input": {
            color: "white",
            fontSize: { xs: "3rem", sm: "3.5rem", md: "4rem" }, // Correctly apply fontSize here
          },
        }}
      />
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, 50px)", // Use a fixed size for columns
          gridAutoRows: "50px", // Explicitly set the auto row height
          justifyContent: "center",
          gap: 1,
          marginBottom: "110px",
          maxWidth: "90vw", // Ensure the container has a max-width
        }}
      >
        {Array.from({ length: y }, (_, i) => (
          <Box
            key={i}
            onClick={() => handleCircleClick(i)}
            sx={{
              width: 50,
              height: 50,
              borderRadius: "50%",
              border: "2px solid white",
              backgroundColor: i < x ? "limegreen" : "transparent",
              margin: "0 auto",
            }}
          />
        ))}
      </Box>
      <Box
        sx={{
          position: "fixed",
          bottom: "20px",
          left: 0,
          right: 0,
          display: "flex",
          justifyContent: "space-around",
          backgroundColor: "white",
          borderRadius: "50px",
          padding: "5px 20px",
          width: "200px",
          margin: "auto",
        }}
      >
        <IconButton
          sx={{ color: "black", "& svg": { fontSize: 60 } }}
          onClick={() => setX(Math.max(0, x - 1))}
        >
          <ArrowDropDown />
        </IconButton>
        <IconButton
          sx={{ color: "black", "& svg": { fontSize: 60 } }}
          onClick={() => setX(Math.min(y, x + 1))}
        >
          <ArrowDropUp />
        </IconButton>
      </Box>
    </Box>
  );
}
